<template>
  <FormErrorMessages
    title="Error messages"
    :formData="formData"
    formType="blitz_registration"
  />
</template>

<script>
  import FormErrorMessages from '@/components/shared/FormErrorMessages'

  export default {
    name: 'SettingsError',
    components: {FormErrorMessages},
    data () {
      return {
        formData: {
          invalidToken: '',
          noToken: ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Blitz/Settings/errors.vue